<template>
    <section class="contenedor">
        <div class="pueba">

            <div class="kt-portlet__head-label espacio-bottom">
                <h3 class="kt-portlet__head-title text-center">
                    <b>Simulador mantenimientos prepagados</b>
                </h3>
                <h5 class="kt-portlet__head-title text-center">
                    <b>Calcula tu ahorro en nuestro simulador y comprueba nuestros beneficios</b>
                </h5>
            </div>
            
            <form class="row" style="display: flex;justify-content: space-around; margin-left: 5%; margin-right: 5%;">
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                    <div class="col barra">
                        <div class="float-left der-icon">
                                <div class="kt-portlet__head-title"><b>{{ "Agencia: " }}</b>
                                    {{ this.agencia.empresa + " " + this.agencia.nombre }}
                                </div>
    
                                <div class="kt-portlet__head-title"><b>{{ "Modelo: " }}</b>
                                    {{ this.vehiculo.dt7 }}
                                </div>
    
                                <div class="kt-portlet__head-title"><b>{{ "Placa: " }}</b>
                                    {{ this.vehiculo.dt2 }}
                                </div>
    
                                <img :src="validarUrl(this.vehiculo.dt8) ? this.vehiculo.dt8 : sinImagen"
                                    class="img-fluid animated zoomIn" draggable="false" />
                        </div>
                    </div>
                </div>

                <div class="col-lg-4"></div>
                <div class="col-lg-2"></div>

                <div class="col-lg-8">
                    <div class="col-lg-12 kt-portlet__head-label">
                        <h5 class="kt-portlet__head-title text-center" style="padding-bottom: 1rem;">
                            <b>Selecciona mínimo 3 mantenimientos consecutivos para cotizar</b>
                        </h5>

                        <div class="pt-2 sub-section">
                            <stepprogress 
                                @valorSuma="ObtenerValores" 
                                :kilimetrajes="vehiculo.elements2"
                                @contador="ObtenerCounter" 
                                :porcentajeIva="this.vehiculo.ndt2"
                                @kilometrajeSeleccionado="obtenerKilometrajeSeleccionado"
                                @valorIvaAplicado="ObtenerIvaAplicado" />
                        </div>
                    </div>

                    <div class="row col-12 outer" style="padding-top: 1.5rem;">
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 card_informacion">
                            <div 
                                class="row text-white col-12 content_card_informacion_header" 
                                style="background:linear-gradient(45deg, #007BE4, #00549e)">
                            
                                <div class="col-2">
                                    <i class="bi-file-earmark-text-fill fa-2x"></i>
                                </div>
                                
                                <div class="col-10 text-left" >
                                    <h5 class="text-white text-left btn-bold">
                                        <b >Detalle cotización</b>
                                    </h5>
                                </div>
                            </div>
                            
                            <div class="col-12 content_card_informacion_body" >
                                <valores-descuento
                                    :kilimetrajes="vehiculo.ndt2" 
                                    :sumaValue="suma"
                                    :contador="contador" 
                                    :descuentos="calculoDescuentos(this.listaDescuentos).valor"
                                    :iva="this.calcularIVA(this.vehiculo.ndt2)"
                                    :subTotal="calcularSubTotal(this.vehiculo.ndt2)"
                                    :total="calcularTotal(this.vehiculo.ndt2)" 
                                />
                            </div>

                            <div 
                                class="row text-white col-12 bg-primary content_card_informacion_footer" 
                                style="background:linear-gradient(45deg, #007BE4, #00549e)">
                                
                                <div class="col-8 text-left">
                                    <h5 class="text-white text-left btn-bold">
                                        <b>Total:</b>
                                    </h5>
                                </div>

                                <div class="col-4">
                                    <h5 class="text-white btn-bold text-right">
                                        <b>$ {{ this.valorTotalTabla | puntos }}</b>
                                    </h5>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 card_informacion">
                            <div 
                                class="row text-white col-12 content_card_informacion_header" 
                                style="background:linear-gradient(45deg, #00A42D, #3a9753)">
                                
                                <div class="col-2">
                                    <i class="bi-star-fill fa-2x"></i>
                                </div>
                                <div class="col-10 text-left">
                                    <h5 class="text-white text-left btn-bold">
                                        <b>Detalle beneficios</b>
                                    </h5>
                                </div>
                            </div>
                            
                            <div class="col-12 content_card_informacion_body">
                                <tabla-beneficios-adicionales 
                                    :listaBeneficios="this.listaBeneficios"
                                    :contador="contador" 
                                />
                            </div>
                            
                            <div class="row text-white col-12 bg-primary content_card_informacion_footer" 
                                style="background:linear-gradient(45deg, #00A42D, #3a9753)">
                                <div class="col-8 text-left">
                                    <h5 class="text-white text-left btn-bold">
                                        <b>Total:</b>
                                    </h5>
                                </div>
                                <div class="col-4">
                                    <h5 class="text-white btn-bold text-right">
                                        <b>$ {{  this.sumarListaBeneficios | puntos }}</b>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <total-cotizacion
                            :sumaValue="suma"
                            :subTotal="calcularSubTotal(this.vehiculo.ndt2)"
                            :ahorro="calcularTotalAhorro(this.vehiculo.ndt2)"
                            :precioNomal="calcularPrecioNormal(this.listaBeneficios)"
                            :porcentajeAhorro="calcularPorcertajeAhorro(this.listaBeneficios)"
                            :contador="contador"
                            :totalCompra="calcularTotalCompra(this.listaBeneficios)"
                            :total="calcularTotal(this.vehiculo.ndt2)" 
                        />
                    </div>
                    
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <formulario-registro 
                        @input="ObtenerFormulario" :titulo="title"
                        @docInval="ObtenerDocInval"/>
                    </div>

                </div>
                <div class="col-lg-2"></div>
            </form>

            
                    <div class="espacioBotones">
                        <div >
                            <button 
                                style="width: 150px"
                                type="button" 
                                class="btn btn-primary btn-font-sm" 
                                v-on:click="cancelar">
                                Cancelar
                            </button>
                        </div>

                        <div >
                            <button 
                                style="width: 150px"
                                type="button" 
                                class="btn btn-primary btn-font-sm"
                                :disabled="this.form == null || this.bloquear || loading|| !this.formularioValido" 
                                :class="{ 'cursor-not-allowed': bloquear || loading || !this.formularioValido}"
                                v-on:click="enviarAsesor('asesor')">
                                <span v-if="loading" class="spinner-border spinner-border-sm" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </span>
                                  <span v-else>Cotizar</span>
                            </button>
                        </div>
                        <div >
                            <button 
                                style="width: 150px"
                                type="button" 
                                class="btn btn-primary btn-font-sm"
                                :disabled="this.form == null || this.bloquear || loading|| !this.formularioValido" 
                                :class="{ 'cursor-not-allowed': bloquear || loading || !this.formularioValido}"
                                v-on:click="enviarAsesor('compra')">
                                <span v-if="loading" class="spinner-border spinner-border-sm" role="status">
                                    <span class="sr-only">Loading...</span>
                                  </span>
                                  <span v-else>Compra en línea</span>
                            </button>
                        </div>
                    </div>
          

        </div>
    </section>
</template>

<script>
import formularioRegistro from '../../componentes/formulario-registro.vue';
import constantes from "../../constantes";
import stepprogress from "./stepProgessSlider.vue";
import ValoresDescuento from './valoresDescuento.vue';
import * as servicios from "../../servicios";
import { isUrl,
         ObtenerDescuentos, 
         ObtenerIva, 
         ObtenerTotal, 
         ObetenerSubTotal, 
         ObtenerTotalAhorro, 
         ObtenerPrecioNormal, 
         ObtenerPorcentajeAhorro,
         ObtenerTotalCompra} from "../../utils";
import store from '../../store';
import iziToast from "izitoast";
import TablaBeneficiosAdicionales from './tablaBeneficiosAdicionales.vue';
import totalCotizacion from './totalCotizacion.vue';

export default {
    nombre: "simulador",
    data: () => ({
        formularioValido: false,
        listaBeneficios: [],
        valorTotalTabla: 0,
        vehiculo: {},
        agencia: {},
        value: 0,
        suma: 0,
        valorIvaAplicado: 0,
        contador: 0,
        listaDescuentos: [],
        iva: 0,
        total: 0,
        subTotal: 0,
        form: null,
        bloquear: true,
        mensajeAdvertencia: false,
        title: constantes.Constantes.textos.titulo,
        sinImagen: require("@/assets/images/no-image.png"),
        uri: process.env.VUE_APP_URL_API,
        lstKilometraje: constantes.Constantes.lstKilometraje,
        formularioDescuentos: {
            suma: 0,
            totalDescuento: 0,
            subTotal: 0,
            iva: 0,
            total: 0,
            porcentajeIva: 0,
            descuentoAplicado: {}
        },
        selectKilometraje: [],
        sumarListaBeneficios:0,
        loading: false,
    }),

    components: { stepprogress, ValoresDescuento, formularioRegistro, TablaBeneficiosAdicionales, totalCotizacion },

    methods: {
    
        enviarAsesor: function (tipo) {
            this.loading = true;
            let listaBeneficios = this.listaBeneficios;
            const mantenimientosCotizar = store.getters.getMantenimientosCotizar
            const formularioEnviar = {
                dt4: store.getters.getVehiculo.dt4,
                dt5: store.getters.getVehiculo.dt6,
                dt8: this.formularioDescuentos.descuentoAplicado.dt1,
                dt9: process.env.VUE_APP_MANT_PREPAGADOS,
                ndt1: this.formularioDescuentos.suma,
                ndt2: this.formularioDescuentos.descuentoAplicado.ndt4,
                ndt3: this.formularioDescuentos.descuentoAplicado.ndt2,
                ndt4: this.formularioDescuentos.totalDescuento,
                ndt5: this.formularioDescuentos.subTotal,
                ndt6: store.getters.getVehiculo.ndt2,
                ndt7: this.formularioDescuentos.iva,
                ndt8: this.formularioDescuentos.total,
                dt35: "",
                // hash1: formulario.hash1,//noc de donde sacar
                hash2: this.formularioDescuentos.descuentoAplicado.hash,//noc de donde sacar
                bdt1: this.$store.getters.getVehiculo.ndt2 > 0 ? true : false,
                bdt2: this.formularioDescuentos.descuentoAplicado != null && this.formularioDescuentos.descuentoAplicado.ndt4 > 0 ? true : false,
                elements: this.selectKilometraje,
                elements2:listaBeneficios
            }
           
            mantenimientosCotizar.push(formularioEnviar);
            this.$store.commit("setManteniminetosCotizar", mantenimientosCotizar);

            servicios.integracionFormulario.registroFormualrio(this.form, tipo.toString() ==="asesor" ? process.env.VUE_APP_PREPAGADOS : process.env.VUE_APP_PREPAGADOS_COMPRA_EN_LINEA).then(res => {
                this.loading = false;
                if(tipo.toString() ==="asesor"){

                    this.$router.push({
                        name: "gracias", 
                       
                    });
                }else{
                    this.$router.push({
                        name: "graciascompralinea",
                       
                    });
                }
                this.$store.commit("setManteniminetosCotizar", []);
                this.$store.commit("setVehiculo", null);
                this.$store.commit("setHome", null);
            }).catch((error) => {
                this.loading = false;
            });
        },

        
        atras: function () {
            this.$router.push({ name: 'p1' })
        },

        cancelar: function () {
            this.$router.push({ name: 'p1' });
        },

        descuentos: function (idAgencia) {
            servicios.descuentos.descuentos(idAgencia, process.env.VUE_APP_MARCA, process.env.VUE_APP_PREPAGADOS_TIPO_DESCUENTO).then((res) => {
                this.listaDescuentos = res.data;
            })
        },

        ObtenerValores(newSuma) {
            this.formularioDescuentos.suma = newSuma
            this.suma = newSuma;
        },

        ObtenerIvaAplicado(valorIva) {
            this.valorIvaAplicado = valorIva;
        },

        consultarBeneficios() {
            servicios.beneficios.beneficios(this.formularioDescuentos.subTotal, this.contador, this.agencia.id, this.obtenerCodigoOperacion(this.selectKilometraje), process.env.VUE_APP_MARCA).then((response) => {
                this.listaBeneficios = response.data;
                if(this.listaBeneficios){
                    this.sumarListaBeneficios = this.listaBeneficios.reduce((accumulator, object) => {
                        return accumulator + object.ndt2;
                    }, 0)
                }
            });
        },

        obtenerCodigoOperacion(listaKilometrajesSeleccionados){
            let result = "";
            var listaOperaciones = listaKilometrajesSeleccionados.map(a => a.dt3);
            listaOperaciones.forEach((element) => result+= element + ";");
            return result;
        },

        ObtenerCounter(newCount) {
            this.contador = newCount;
            if (this.contador != null) {
                if (this.contador > 2) {
                    this.bloquear = !this.ValidarSeleccionKm(this.selectKilometraje, this.vehiculo.elements2);
                } else {
                    this.bloquear = true
                }
            } else {
                this.bloquear = true;
            }

            if (this.selectKilometraje.length > 1) {

                this.mensajeAdvertencia = !this.ValidarSeleccionKm(this.selectKilometraje, this.vehiculo.elements2);
            } else {
                this.mensajeAdvertencia = false;
            }
            if (this.mensajeAdvertencia === true) {
                iziToast.error({
                    theme: "light",
                    position: "bottomRight",
                    message: "Solo se permite seleccionar mantenimientos consecutivos, y mínimo 3 para generar la cotización.",
                });
            }
            this.consultarBeneficios();
        },

        ValidarSeleccionKm: function (kilometrajesSeleccionados, kilometrajes) {
            if (kilometrajesSeleccionados != null && kilometrajes != null) {
                if (kilometrajesSeleccionados.length > 0) {
                    kilometrajesSeleccionados.sort((a, b) => (a.ndt1 > b.ndt1) ? 1 : (a.ndt1 < b.ndt1) ? -1 : 0);
                    let kmSeleccionadoValidar = 0;
                    let kmValidar = kilometrajes.findIndex((element) => element == kilometrajesSeleccionados[kmSeleccionadoValidar]);
                    if (kmValidar != null) {
                        while ((kmValidar <= kilometrajes.length - 1) && (kmSeleccionadoValidar <= kilometrajesSeleccionados.length - 1)) {
                            if (kilometrajesSeleccionados[kmSeleccionadoValidar].ndt1 != kilometrajes[kmValidar].ndt1) {
                                return false;
                            }
                            kmSeleccionadoValidar += 1;
                            kmValidar += 1;
                        }
                        return true;
                    }
                }
            }
        },

        obtenerKilometrajeSeleccionado(newSelect) {
            this.selectKilometraje = newSelect
        },

        validarUrl(url) {
            return isUrl(url)
        },

        calculoDescuentos(valor) {
            const descuentoObtenido = ObtenerDescuentos(valor, this.suma)
            this.formularioDescuentos.totalDescuento = descuentoObtenido.valor;
            this.formularioDescuentos.descuentoAplicado = descuentoObtenido.descuento;
            return descuentoObtenido
        },

        calcularIVA(iva) {
            //return this.valorIvaAplicado;
            let valorIva = ObtenerIva(ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma, iva);
            this.formularioDescuentos.iva = valorIva;
            return valorIva;
        },

        calcularSubTotal(valor) {
            this.formularioDescuentos.subTotal = ObetenerSubTotal(ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma);
            return ObetenerSubTotal(ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma)
        },

        calcularTotal(iva) {
            let total = ObtenerTotal(this.calcularIVA(iva), ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma);
            this.formularioDescuentos.total = total;
            this.valorTotalTabla = total;
            return total;
        },

        ObtenerFormulario(newFormulario) {
            this.form = newFormulario;
        },

        

        calcularTotalAhorro(){
            return ObtenerTotalAhorro(ObetenerSubTotal(ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma), this.suma, this.sumarListaBeneficios)
        },

        calcularPrecioNormal(){
            return ObtenerPrecioNormal(this.listaBeneficios, this.suma)
        },

        calcularPorcertajeAhorro(){
            var totalAhorro = ObtenerTotalAhorro(ObetenerSubTotal(ObtenerDescuentos(this.listaDescuentos, this.suma).valor, this.suma), this.suma, this.sumarListaBeneficios);
            var precioNormal = ObtenerPrecioNormal(this.listaBeneficios, this.suma);
            return ObtenerPorcentajeAhorro(totalAhorro,precioNormal)
        },

        calcularTotalCompra(){
            return ObtenerTotalCompra(this.valorTotalTabla,  this.sumarListaBeneficios)
        },

        ObtenerDocInval(newVal) {
            this.formularioValido = newVal
        },
        // pagoLinea: function () { 
        //     const mantenimientosCotizar = store.getters.getMantenimientosCotizar
        //     const formularioEnviar = {
        //         dt4: store.getters.getVehiculo.dt4,
        //         dt5: store.getters.getVehiculo.dt6,
        //         dt8: this.formularioDescuentos.descuentoAplicado.dt1,
        //         dt9: process.env.VUE_APP_MANT_PREPAGADOS,
        //         ndt1: this.formularioDescuentos.suma,
        //         ndt2: this.formularioDescuentos.descuentoAplicado.ndt4,
        //         ndt3: this.formularioDescuentos.descuentoAplicado.ndt2,
        //         ndt4: this.formularioDescuentos.totalDescuento,
        //         ndt5: this.formularioDescuentos.subTotal,
        //         ndt6: store.getters.getVehiculo.ndt2,
        //         ndt7: this.formularioDescuentos.iva,
        //         ndt8: this.formularioDescuentos.total,
        //         // hash1: formulario.hash1,//noc de donde sacar
        //         hash2: this.formularioDescuentos.descuentoAplicado.hash,//noc de donde sacar
        //         bdt1: this.formularioDescuentos.porcentajeIva > 0 ? true : false,
        //         bdt2: this.formularioDescuentos.descuentoAplicado === null && this.formularioDescuentos.descuentoAplicado.ndt4 > 0 ? false : true,

        //         elements:this.selectKilometraje
        //     }
        //     mantenimientosCotizar.push(formularioEnviar)
        //     this.$store.commit("setManteniminetosCotizar", mantenimientosCotizar);
        //     servicios.integracionFormulario.registroFormualrio(this.form, process.env.VUE_APP_PREPAGADOS_COMPRA_EN_LINEA).then(res => {

        //         this.$router.push({
        //             name: "login",
        //             params: {
        //                 titulo: this.$route.params.titulo,
        //                 id: this.$route.params.id,
        //             },
        //         });

        //         this.$store.commit("setManteniminetosCotizar", []);
        //         this.$store.commit("setVehiculo", null);
        //         this.$store.commit("setHome",  null);
        //     })
        // },
    },

    props: [],

    filters: {
        puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
    },

    mounted() {
        this.vehiculo = this.$store.getters.getVehiculo;
        this.agencia = this.$store.getters.getHome.agencia;
        this.descuentos(this.agencia.id);
        //this.consultarBeneficios();
    },

    watch: {
        suma: {
            immediate: true,
            handler(val, oldVal) { }

        },

        contador: {
            immediate: true,
            handler(val, oldVal) { }
        },
    }
}
</script>

<style>
.margenes1 {
    display: flex;
    justify-content: space-around;
    margin-left: 5%;
    margin-right: 5%;
}

.espacioFormulario {
    margin-left: 18%;
    margin-right: 18%;
}

.cursor-not-allowed {
    cursor: not-allowed;
}

.letra-color{
    color:#fff
}

.space{
    padding-top: 2rem;
}

.espacio-bottom{
    padding-bottom: 1.5rem;
}

:root {
    --md-theme-inverso-primary: #F0F0F0 !important;
    --md-theme-inverso-accent: #3AAC5D !important;
    --md-theme-inverso-theme: light !important;
}

.card_informacion{
    margin-bottom: 12px; 
    display: flex; 
    flex-wrap: wrap; 
    align-content: space-between;
    justify-content: flex-end;
}

.content_card_informacion_header{
    padding: 1rem 0.5rem; 
    height: 15%; 
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: space-evenly;
    align-items: baseline;
}

.content_card_informacion_body{
    height: 75%
}

.content_card_informacion_footer{
    padding: 1rem 0.5rem;  
    height: 10%; 
    display: flex;
    flex-wrap: wrap;
    align-content: center;
}

.espacioBotones{
    display: flex;
    justify-content: space-evenly;
}

</style>
